import { CompletionItemType } from '../model';
import type { CompletionButton, CompletionGroup, CompletionItem, CompletionOption, CompletionSection } from '../model';
import type { ConcreteDataType, DataType, ParameterDef } from '@thinkalpha/language-services';
import type { Observable } from 'rxjs';
import type { IndicatorViewModelOrImportViewModel } from 'src/lib/dictionaryModel';

export const DEFAULT_INDICATOR_KEY = 'ticker';

export const indicatorCompletionOptionType = Symbol('indicator');
export interface IndicatorCompletionOption extends CompletionOption {
    indicator: IndicatorViewModelOrImportViewModel;
    optionType: typeof indicatorCompletionOptionType;
    params?: ParameterDef[];
    returnType?: DataType;
}

export const isIndicatorCompletionOption = (option: CompletionItem): option is IndicatorCompletionOption =>
    option.type === CompletionItemType.option && option.optionType === indicatorCompletionOptionType;

export type IndicatorCompletionItem =
    | IndicatorCompletionOption
    | CompletionOption
    | CompletionSection
    | CompletionGroup
    | CompletionButton;
export type CompletionItemRetrieverArgs = { search: string; type?: ConcreteDataType };
export type CompletionItemSource =
    | readonly CompletionItem[]
    | undefined
    | ((args: CompletionItemRetrieverArgs) => Observable<readonly CompletionItem[] | undefined>);

export interface CompletionContext {
    index: number;
    text: string;
    options: readonly CompletionItem[] | undefined;
}

export enum CompletionOptionType {
    field = 'field',
    function = 'function',
    syntax = 'syntax',
}

export function selectIcon(type: CompletionOptionType) {
    switch (type) {
        case CompletionOptionType.field:
            return 'columns';
        case CompletionOptionType.function:
            return 'function';
        case CompletionOptionType.syntax:
            return 'code';
        default:
            throw new Error('Unsupported completion type. No icon available.');
    }
}
